module Dashboard {
    "use strict";
    
    /**
     * This directive dynamically appends widget directives on the DOM e.g <frends-agents-widget />
     * It receives the widget config from DashboardConfigService.widgets, and is bound one way. This way, changes get passed down, but don't bubble up.
     */
    export function frendsWidgetWriter($compile): ng.IDirective {
        return {
            restrict: "E",
            replace: true,
            scope: { config: "&" },
            link: (scope: IWidgetWriterScope, element) => {
                let template = "<" + scope.config().directiveName + " config='config()' class='fill-parent'/>";
                let content = $compile(template)(scope);
                element.append(content);
            }
        }
    }

    module.directive("frendsWidgetWriter", ["$compile", frendsWidgetWriter]);

    export interface IWidgetWriterScope extends ng.IScope {
        config(): IWidgetConfig;
    }
}